import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import * as d3Scale from "d3-scale";
import * as d3Shape from "d3-shape";
import * as d3Array from "d3-array";
import * as d3Axis from "d3-axis";
import * as d3 from "d3";
import { DynaDimmerStateService } from "../../../core-module/services/state/dyna-dimmer-state.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
import {
  updateScenes10 as _updateScenes10,
  updateScenes9 as _updateScenes9,
  updateScenes8 as _updateScenes8,
  updateScenes7 as _updateScenes7,
  updateScenes6 as _updateScenes6,
  updateScenes5 as _updateScenes5,
  updateScenes4 as _updateScenes4,
  updateScenes3 as _updateScenes3,
  updateScenes2 as _updateScenes2,
} from "../../graph-utils/dyna-scene-updates";
import {
  addTMAXShutDown as _addTMAXShutDown,
  addTMAXStart as _addTMAXStart,
  addTMAXEnd as _addTMAXEnd,
} from "../../graph-utils/dyna-tmax-markers";
import {
  drawDynaLineAndPath as _drawDynaLineAndPath,
  addDynaDrag as _addDynaDrag,
  dragEndedDyna as _dragEndedDyna,
  buildDynaDataPoints,
} from "../../graph-utils/dyna-graph-common";
@Component({
  standalone: false,
  selector: "app-sampledynagraph",
  templateUrl: "./sampledynagraph.component.html",
  styleUrls: ["./sampledynagraph.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SampledynagraphComponent implements OnInit {
  @Input() readOnly: boolean = true;

  inputXRange = [0, 24];

  inputYRange = [0, 100];

  data1: LegacyAny[] = [
    { dyanXTime: 0, dyanYOutput: 40 },
    { dyanXTime: 15, dyanYOutput: 40 },
    { dyanXTime: 15, dyanYOutput: 100 },
    { dyanXTime: 16, dyanYOutput: 100 },
    { dyanXTime: 16, dyanYOutput: 10 },
    { dyanXTime: 17, dyanYOutput: 10 },
    { dyanXTime: 17, dyanYOutput: 80 },
    { dyanXTime: 18, dyanYOutput: 80 },
    { dyanXTime: 18, dyanYOutput: 30 },
    { dyanXTime: 19, dyanYOutput: 30 },
    { dyanXTime: 19, dyanYOutput: 40 },
    { dyanXTime: 24, dyanYOutput: 40 },
    // {dyanXTime:"00", dyanYOutput:10},
    // {dyanXTime:"03", dyanYOutput:10},
    // {dyanXTime:"03", dyanYOutput:80},
    // {dyanXTime:"20", dyanYOutput:80},
    // {dyanXTime:"20", dyanYOutput:10},
    // {dyanXTime:"24", dyanYOutput:10}
  ];
  data: LegacyAny[] = [];
  dataFromTableValues: LegacyAny[] = [];

  focus;
  drag;
  public margin = { top: 50, right: 50, bottom: 50, left: 50 };
  public width: number;
  public height: number;
  public x: LegacyAny;
  public y: LegacyAny;
  public svg3: LegacyAny;
  public line: d3.Line<[number, number]>; // this is line defination
  public area: d3.area<[number, number]>; // this is area defination
  public id = "lineChart";
  public color2 = "#00b36b";
  newData: LegacyAny;
  changedPoint: LegacyAny;
  feedMaxValue: LegacyAny = 112;
  NormalLevelMaximum: LegacyAny;
  BackgroundLevelMaximum: LegacyAny;
  Maxdata: LegacyAny = [];
  Tmaxstart: LegacyAny;
  TmaxEnd: LegacyAny;
  TmaxShutDown: LegacyAny;
  scrolPoint: LegacyAny;
  deRatingdyanYOutput: LegacyAny;
  LamOffValue: LegacyAny;
  DtlDimStopValue: LegacyAny;
  TmaxdeRatingDim: LegacyAny;
  Forbidenarea: d3.area<[number, number]>; // this is area defination
  deratingLabelYaxis: number;
  TminEnd: LegacyAny;
  MaxLimit: LegacyAny;
  TmindeRatingDim: LegacyAny;

  constructor(
    private dynaDimmer: DynaDimmerStateService,
    private graphState: GraphStateService
  ) {}

  ngOnInit() {
    // this.dynaDimmer.getDynaTimeReferencedMode.subscribe(response => {

    //   if(response===true)
    //   {
    //     this.dynaDimmer.getFinalDynaDimmerData.subscribe(response=>{
    //       this.addDynaDetails(response);

    //     });
    //   }
    // })
    this.dynaDimmer.getFinalDynaDimmerData.subscribe((response) => {
      this.addDynaDetails(response);
    });

    this.newData = this.data;

    this.buildSvg();
    this.addXandYAxis();
    this.drawLineAndPath();
    this.addDrag();
  }

  private clampOutputLevels(data: LegacyAny[]) {
    // Clamp output values to graph bounds [0, 100] to prevent out-of-bounds rendering
    for (const item of data) {
      const outVal = parseInt(item.outputLevel);
      if (outVal > 100) {
        item.outputLevel = "100";
      }
      if (outVal < 0) {
        item.outputLevel = "0";
      }
    }
  }

  addDynaDetails(response: LegacyAny) {
    if (!response) {
      return;
    }
    const newData1 = JSON.parse(response);
    this.data = [];
    this.dataFromTableValues = [];
    this.clampOutputLevels(newData1);
    this.dataFromTableValues = buildDynaDataPoints(newData1);
    this.data = this.dataFromTableValues;
    this.buildSvg();
    this.addXandYAxis();
    this.drawLineAndPath();
    this.addDrag();
  }
  public buildSvg() {
    this.svg3 = d3.select("#svg3");
    this.width = 600 - this.margin.left - this.margin.right;
    this.height = 550 - this.margin.top - this.margin.bottom;
  }
  public addXandYAxis() {
    // range of data configuring
    this.x = d3.scaleLinear().range([0, this.width]);
    this.y = d3.scaleLinear().range([this.height, 0]);
    this.x.domain(this.inputXRange);
    this.y.domain(this.inputYRange);
  }

  public drawLineAndPath() {
    // Delegated to shared dyna-graph-common.drawDynaLineAndPath.
    // sampledynagraph-specific: clampY=true, gradient5, x-label at x(15),
    // no inline x-grid tick format (make_x_gridlines carries its own).
    _drawDynaLineAndPath.call(this, {
      hostSvg: this.svg3,
      gradientId: "gradient5",
      xLabelAnchor: 15,
      clampY: true,
    });
  }

  // gridlines in x axis function
  make_x_gridlines() {
    return d3
      .axisBottom(this.x)
      .ticks(24)
      .tickFormat(
        (d, i) =>
          [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
            19, 20, 21, 22, 23, 24,
          ][i]
      );

    //tickFormat(x=>`(${x.toFixed(1)})`);
  }
  // gridlines in y axis function
  make_y_gridlines() {
    return d3.axisLeft(this.y).ticks(10);
  }

  public addDrag() {
    _addDynaDrag.call(this);
  }

  dragstarted() {
    return this;
  }

  public dragended(d) {
    _dragEndedDyna.call(this, d);
  }

  ///SCENE 10


  ///SCENE 10 - delegated to shared dyna-scene-updates helpers
  updateScenes10(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes10.call(this, data, draggedData);
  }
  updateScenes9(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes9.call(this, data, draggedData);
  }
  updateScenes8(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes8.call(this, data, draggedData);
  }
  updateScenes7(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes7.call(this, data, draggedData);
  }
  updateScenes6(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes6.call(this, data, draggedData);
  }
  updateScenes5(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes5.call(this, data, draggedData);
  }
  updateScenes4(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes4.call(this, data, draggedData);
  }
  updateScenes3(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes3.call(this, data, draggedData);
  }
  updateScenes2(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes2.call(this, data, draggedData);
  }

  getDynaTimeXRefernce(dynaModX: number) {
    const hh = dynaModX.toString().split(".")[0];
    let mm = "00";

    try {
      mm = dynaModX.toString().split(".")[1].substring(0, 2);
      if (mm.length === 1) {
        mm = mm.concat("0");
      }
    } catch (error) {}
    if (Number(mm) > 59) mm = "59";
    return hh + ":" + mm;
  }

  addDeratingLine() {
    this.focus
      .append("line")
      .style("stroke", "grey")
      .style("stroke-dasharray", "5, 5")
      .text("Derating")
      .attr("x1", 0)
      .attr("y1", this.y(this.deRatingdyanYOutput))
      .attr("x2", this.x(230))
      .attr("y2", this.y(this.deRatingdyanYOutput));

    this.focus
      .append("text")
      .attr("x", this.x(-this.deratingLabelYaxis))
      .attr("y", this.y(this.deRatingdyanYOutput))
      .attr(
        "transform",
        "rotate(-90," +
          this.x(-this.deratingLabelYaxis) +
          "," +
          this.y(this.deRatingdyanYOutput) +
          ")"
      )
      .attr("text-anchor", "start")
      .style("font", "10px Signify-Relative-Bold")
      .style("color", "lightgrey")
      .style("text-anchor", "middle")
      .text("Derating");
  }

  addTMAXShutDown() {
    _addTMAXShutDown.call(this);
  }

  addTMAXStart() {
    _addTMAXStart.call(this);
  }

  addTMAXEnd() {
    _addTMAXEnd.call(this);
  }
}

